import React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { Logo } from "../../assets/logo";
import { useTheme } from "../context";

interface BrandLogoProps {
  alt?: string;
  sx?: SxProps<Theme>;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ alt = "Logo", sx }) => {
  const { mode, branding } = useTheme();
  const logoUrl =
    mode === "dark"
      ? branding?.dark_logo_url ??
        branding?.logo_dark_url ??
        branding?.logo_url
      : branding?.logo_url;

  if (!logoUrl) {
    return <Logo />;
  }

  return (
    <Box
      component="img"
      src={logoUrl}
      alt={alt}
      sx={{
        display: "block",
        maxWidth: "100%",
        maxHeight: "100%",
        ...sx,
      }}
    />
  );
};
